import { HeartPulse, ShieldCheck, Home, Clock, Users, Stethoscope } from "lucide-react";
import { ScrollReveal } from "@/components/ScrollReveal";
import { TRUST_BADGES } from "@/data/content";

const ICONS = { HeartPulse, ShieldCheck, Home, Clock, Users, Stethoscope };

export const TrustBadges = () => {
  return (
    <section className="bg-bone py-20 lg:py-28" data-testid="trust-badges-section">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 border-t border-l border-navy/15">
          {TRUST_BADGES.map((badge, i) => {
            const Icon = ICONS[badge.icon];
            return (
              <ScrollReveal key={i} delay={i * 0.06}>
                <div
                  className="group card-lift border-r border-b border-navy/15 p-6 lg:p-8 h-full flex flex-col gap-4 bg-bone hover:bg-white hover:shadow-[0_18px_40px_rgba(15,31,61,0.07)]"
                  data-testid={`trust-badge-${i}`}
                >
                  <Icon size={26} className="text-teal group-hover:scale-110 group-hover:-translate-y-0.5 transition-transform duration-500" strokeWidth={1.5} />
                  <p className="text-sm text-navy leading-snug font-medium">
                    {badge.label}
                  </p>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
